var open_popup_external, pullVideo, exitVideo;
jQuery(document).ready(function() {
  /*
   * Contact page confirm email
   */
	var handle = setInterval(function() {
     // No better way to differeniate inputs since the frontend assigns the same id to both
     var $email_field         = jQuery('input[type="email"][name="field_59093"]');
     var $email_confirm_field = jQuery('input[type="email"][name="field_59128"]');

     if ($email_field.length > 0) {
       clearInterval(handle);
       $email_field.on('change input', update_confirm_email_state);
       $email_confirm_field.on('change input', update_confirm_email_state);
     }
   }, 500);

   function update_confirm_email_state() {
     var $email_field         = jQuery('input[type="email"][name="field_59093"]');
     var $email_confirm_field = jQuery('input[type="email"][name="field_59128"]');
     var $submit_btn          = jQuery('button[type="submit"].esc--btn-submit');
     
     $submit_btn.attr('id', 'contact-submit-btn');

     var compare = {
       val_1: $email_field.val(),
       val_2: $email_confirm_field.val(),
     };

     if(compare.val_1 === compare.val_2) {
       $email_confirm_field.removeClass('invalid');
       enable_submit_button($submit_btn);
     } else {
       $email_confirm_field.addClass('invalid');
       disable_submit_button($submit_btn);
     }
   }

   function enable_submit_button($submit_btn) {
     $submit_btn.attr("disabled", false);
     $submit_btn.removeClass('invalid');
   }

   function disable_submit_button($submit_btn) {
     $submit_btn.attr("disabled", true);
     $submit_btn.addClass('invalid');
   }

  /*
   * FAQ page pull-downs
   */
   var faq_page = jQuery('.faqColor .list-context');
   if(faq_page.length > 0) {
     var list_context = faq_page.find('.context');
     list_context.each(assign_question_pulldown_on_click);
   }

   function assign_question_pulldown_on_click() {
     var $context = jQuery(this);
     var $context__title = $context.find('.context__title-row');
     var $context__list_question = $context.find('.context__list-question');

     $context__title.on('click', function () {
       $context__list_question.slideToggle();
       $context__title.toggleClass('active');
     });
     $context__list_question.find('.context__question-row').each(assign_answer_pulldown_on_click);
   }

   function assign_answer_pulldown_on_click() {
     var $content__question = jQuery(this);
     var uniq_id = $content__question.prop('id');
     var uniq_selector = ('#' + uniq_id + '.context__html-answer-wrap');
     var $content__answer = jQuery(uniq_selector);

     $content__question.on('click', function () {
       $content__answer.slideToggle();
       $content__question.toggleClass('active');
     });
   }

  /*
   * Auto-focus search page input
   */
  jQuery('.search-form .form__input').focus();

  /*
   * Popup
   */
  pullVideo = function(e) {
    setCookie('video_is_open', true, 1);
    if (e.id === "video1") {
      var targetVideo1 = document.getElementById("popup1");
      targetVideo1.style.top = "0vh";
      targetVideo1.style.transform = "scale3d(1, 1, 1)";
      var targetiFrames1 = targetVideo1.getElementsByClassName('iframeVideo');
      var targetiFrame1 = targetiFrames1[0]
      var player1 = $f(targetiFrame1);
      player1.api("play");
    } else if (e.id === "video2") {
      var targetVideo2 = document.getElementById("popup2");
      targetVideo2.style.top = "0vh";
      targetVideo2.style.transform = "scale3d(1, 1, 1)";
      var targetiFrames2 = targetVideo2.getElementsByClassName('iframeVideo');
      var targetiFrame2 = targetiFrames2[0]
      var player2 = $f(targetiFrame2);
      player2.api("play");
    } else if (e.id === "video3") {
      var targetVideo3 = document.getElementById("popup3");
      targetVideo3.style.top = "0vh";
      targetVideo3.style.transform = "scale3d(1, 1, 1)";
      var targetiFrames3 = targetVideo3.getElementsByClassName('iframeVideo');
      var targetiFrame3 = targetiFrames3[0]
      var player3 = $f(targetiFrame3);
      player3.api("play");
    } else if (e.id === "video4") {
      var targetVideo4 = document.getElementById("popup4");
      targetVideo4.style.top = "0vh";
      targetVideo4.style.transform = "scale3d(1, 1, 1)";
      var targetiFrames4 = targetVideo4.getElementsByClassName('iframeVideo');
      var targetiFrame4 = targetiFrames4[0]
      var player4 = $f(targetiFrame4);
      player4.api("play");
    } else if (e.id === "video5") {
      var targetVideo5 = document.getElementById("popup5");
      targetVideo5.style.top = "0vh";
      targetVideo5.style.transform = "scale3d(1, 1, 1)";
      var targetiFrames5 = targetVideo5.getElementsByClassName('iframeVideo');
      var targetiFrame5 = targetiFrames5[0]
      var player5 = $f(targetiFrame5);
      player5.api("play");
    } else if (e.id === "popupEmailAcquisition") {
      var popupEmailAcquisition = document.getElementById("popupEmailAcquisition");
      popupEmailAcquisition.style.top = "0vh";
      popupEmailAcquisition.style.transform = "scale3d(1, 1, 1)";
    }
  }

  exitVideo = function() {
    var popups = document.getElementsByClassName("videoPopup");
    for (var i = 0; i < popups.length; i++) {
      popups[i].style.top = "100vh";
      popups[i].style.transform = "scale3d(1, 1, 0)";
    }

    var iframe = document.getElementById('video');
    var player = $f(iframe);
    player.api("pause");

    // Youtube video pause
    var iframes = document.getElementsByClassName("iframeVideo");
    for (var i = 0; i < iframes.length; i++) {
      iframes[i].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    }

    // Time based popup related
    var endTime = new Date().getTime();
    var original_endTime = getCookie('email_acquisition');
    setCookie('email_acquisition', Math.max(endTime, original_endTime), 7);
    eraseCookie('video_is_open');
  }

  /*
   * Cart Page iframe popup
   */
  reveal_purchase_order_form = function() {
    var $po_form = jQuery('.cart-container .purchase-order-upload');
    $po_form.show();
  }
  open_popup_external = function(url) {
    function PopupCenter(url, title, w, h) {
      // Fixes dual-screen position                         Most browsers      Firefox
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      var left = ((width / 2) - (w / 2)) + dualScreenLeft;
      var top = ((height / 2) - (h / 2)) + dualScreenTop;
      var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

      // Puts focus on the newWindow
      if (window.focus) {
        newWindow.focus();
      }
    }

    PopupCenter(url, '', 473, 673);
  }

  /*
   * Time based popup
   */
  var time_til_trigger;
  var timing = $('#popupEmailAcquisition').data('timing');
  var timing_navd_away = $('#popupEmailAcquisition').data('timing-nav-away');
  setCookie('video_is_open', false, 1);
  eraseCookie('video_is_open'); // case user did not close popup
  if (getCookie('email_acquisition') === null) { // case closed video and nav'd away
    time_til_trigger = (1000 * timing); // 2min (default) + 5sec
  } else {
    time_til_trigger = (1000 * timing_navd_away);
  }

  if (getCookie('email_acquisition_seen') === null) {
    setCookie('email_acquisition', new Date().getTime(), 7);
    var handle = setInterval(open_newsletter_popup, 5000);
  }

  function open_newsletter_popup() {
    var delta = (new Date()).getTime() - getCookie('email_acquisition');
    if (getCookie('video_is_open') !== 'true') {
      if (delta > time_til_trigger) {
        setCookie('email_acquisition_seen', true, 7);
        clearInterval(handle);
        pullVideo({
          id: 'popupEmailAcquisition'
        });
      }
    } else {
      time_til_trigger = (1000 * 60 * 0.5);
    }
  }

  // Functions
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }


});
